<template>
  <slot>
    <router-view/>
  </slot>
</template>
<script lang="ts" setup>
defineOptions({
  name: 'StoreBase',
});
</script>